// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ModalController from "./modal_controller";
import DropdownController from "./dropdown_controller";
import CheckboxController from "./checkbox_controller";
import RedirectController from "./redirect_controller";
import PaymentController from "./payment_controller";
import PlanController from "./plan_controller";
import CreateInstanceController from "./create_instance_controller";
import RegistrationController from "./registration_controller";
import { ContactFormController, LiveROIFormController } from "./contact_form_controller";
import ExpanderController from "./expander_controller";

application.register("modal", ModalController)
application.register("dropdown", DropdownController)
application.register("checkbox", CheckboxController)
application.register("redirect", RedirectController)
application.register("payment", PaymentController)
application.register("plan", PlanController)
application.register("create-instance", CreateInstanceController)
application.register("registration", RegistrationController)
application.register("contact-form", ContactFormController)
application.register("live-roi-form", LiveROIFormController)
application.register("expander", ExpanderController)
